import React from 'react';

const EquityPortfolioQualityComponent = () => {
  const portfolioQuality="https://jamaappprod.s3.ap-south-1.amazonaws.com/Website/maxwealthweb/Web-Images+compressed/Roots+and+Wings%2C+3lens+and+LSG/Equity+Portfolio+.png";
  return (
    <div className="bg-white">
      <div className="max-w-6xl w-full mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 lg:py-8">
        <div className="flex flex-col md:flex-row items-center gap-8">
          {/* Image side */}
          <div className="w-full md:w-2/5">
            <img 
              src={portfolioQuality} 
              alt="Equity Portfolio Quality" 
              className="rounded-lg w-full h-auto object-cover"
            />
          </div>
          
          {/* Content side */}
          <div className="w-full md:w-3/5">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#113262] mb-4">Lens 1: Equity Portfolio Quality</h2>
            <h3 className="text-lg font-medium text-gray-800 mb-4">Focus: Financial Strength of Underlying Companies</h3>
            
            <p className="text-gray-700 mb-4">
              We look under the hood of equity mutual funds to assess the companies they're investing in. 
              This is not a surface-level review—it's a deep dive into balance sheets and business fundamentals.
            </p>
            
            <h4 className="font-medium text-[#113262] mb-2">What we look for:</h4>
            <ul className="mb-4 space-y-2">
              {[
                'Low debt and financially stable balance sheets',
                'High Return on Equity (ROE), aligned with shareholder interests',
                'Strong promoter ownership and corporate governance'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-gray-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <h4 className="font-medium text-[#113262] mb-2">What we avoid:</h4>
            <ul className="mb-4 space-y-2">
              {[
                'Funds with high exposure to risky or poorly run companies',
                'Stocks with weak profitability and high leverage',
                'Funds holding turnaround stories with no real earnings visibility'
              ].map((item, index) => (
                <li key={index} className="flex items-start">
                  <svg className="h-5 w-5 text-red-500 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                  </svg>
                  <span className="ml-2 text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
            
            <p className="text-gray-700">
              This is where our <span className="font-bold">Roots & Wings</span> stock-picking philosophy plays a central role.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquityPortfolioQualityComponent;